import React, { useState, useEffect, useRef } from "react";
import images from "../../../images";
import CommonModal from "../../../components/common/Modal/ModalCommon";
import { useTranslation } from "react-i18next";
import Button from "../../../components/common/Button/Button";
import { cn } from "../../../Utils/helper";
const Timer = ({
  time,
  handleEndQuest,
  questId,
  isStatic = false,
  className,
  // typeImageOclock = false,
}) => {
  const { t } = useTranslation();
  const [isBlinking, setIsBlinking] = useState(false);
  const [showText, setShowText] = useState(true);
  const [currentTime, setCurrentTime] = useState(time);
  // const initialTimeRef = useRef(null);
  const lastTimeRef = useRef(time);
  const outQuestModelRef = useRef(null);
  useEffect(() => {
    if (isStatic) {
      setCurrentTime(time);
      return;
    }

    lastTimeRef.current = time;
    setCurrentTime(time);
  }, [time, questId, isStatic]);

  const formatTime = (seconds) => {
    const totalSeconds = Math.round(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  const totalTime = time;
  const percentageRemaining =
    totalTime > 0 ? (currentTime / totalTime) * 100 : 100;
  const isHalfTimeLeft = percentageRemaining <= 50;
  const isQuarterTimeLeft = percentageRemaining <= 25;

  // console.log("isQuarterTimeLeft", isQuarterTimeLeft);

  useEffect(() => {
    if (isStatic) return;

    if (isHalfTimeLeft) {
      const blinkInterval = setInterval(() => {
        setShowText((prev) => !prev);
      }, 500);
      setIsBlinking(true);
      return () => clearInterval(blinkInterval);
    } else {
      setIsBlinking(false);
      setShowText(true);
    }
  }, [isHalfTimeLeft, isStatic]);

  useEffect(() => {
    if (isStatic || !outQuestModelRef.current) return;

    if (currentTime === 0) {
      outQuestModelRef.current.openModal();
    }
  }, [currentTime, isStatic]);

  const timerBackgroundColor = isQuarterTimeLeft
    ? "bg-[#FFDDE1]"
    : isHalfTimeLeft
    ? "bg-stone-200"
    : "bg-stone-200";
  const textColor = isQuarterTimeLeft ? "text-[#EF4056]" : "text-zinc-800";

  return (
    <div
      className={cn(
        "flex gap-1 justify-center items-center self-center p-1.5 mt-4 text-base whitespace-nowrap rounded-b-md ",
        timerBackgroundColor,
        className
      )}
    >
      <div className="flex gap-1 items-center self-stretch px-1.5 py-0.5 my-auto rounded min-h-[22px]">
        <img
          loading="lazy"
          src={
            isQuarterTimeLeft ? images.PauseBlackIcon : images.PauseBlackIcon
          }
          className={`object-contain shrink-0 self-stretch my-auto w-4 aspect-square ${
            isBlinking && !isStatic
              ? showText
                ? "opacity-100"
                : "opacity-30"
              : ""
          }`}
          alt=""
        />
        <div
          className={`self-stretch my-auto ${textColor} ${
            isBlinking && !isStatic
              ? showText
                ? "opacity-100"
                : "opacity-30"
              : ""
          }`}
        >
          {formatTime(currentTime)}
        </div>
      </div>

      {!isStatic && (
        <CommonModal
          ref={outQuestModelRef}
          title={t("quest.detailMultipleChoice.timeUp")}
          classNameText="text-[#201D1B] font-medium text-lg "
          canClickOverLay={false}
          actions={(closeModal) => (
            <>
              <Button
                text={t("base.ok")}
                className="flex-1 shrink gap-2.5 self-stretch px-5 py-3 rounded-xl min-h-[40px] text-white bg-[#253FF6]"
                variant="primary"
                onClick={() => {
                  closeModal();
                  handleEndQuest();
                }}
              />
            </>
          )}
        >
          <div className="flex justify-center items-center w-full px-4">
            <span className="text-sm font-normal text-[#787A7A] break-words text-wrap text-center">
              {t(
                "quest.detailMultipleChoice.missionHasEndPleaseExitAndTryAgain"
              )}
            </span>
          </div>
        </CommonModal>
      )}
    </div>
  );
};
export default Timer;
